"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triaAuthUrl = exports.TRIA_WALLET_SELECTED_CHAIN = exports.TRIA_WALLET_STORE = exports.eventTypes = void 0;
exports.eventTypes = {
    logIn: 'Log in',
    triaSignUp: 'Tria Sign up',
    socialSignUp: 'Social Sign up',
    signMessage: 'Sign Message',
    send: 'Send',
    disconnect: 'Disconnect',
    switchChain: 'Switch chain',
    detected: 'Detected Logged in Tria account',
    logout: 'Logout',
    passMessage: 'Pass Message',
    accessToken: 'Access Token Pass',
};
exports.TRIA_WALLET_STORE = 'tria.wallet.store';
exports.TRIA_WALLET_SELECTED_CHAIN = 'tria.wallet.selectedChain';
exports.triaAuthUrl = 'https://auth.tria.so';
// export const PARENT_URL = document?.referrer || window?.parent?.[0]?.location?.ancestorOrigins?.[0];
